<template>
  <VDialog 
    :modelValue="show" 
    @update:modelValue="$emit('update:show', $event)" 
    :loading="isProcessing"
    :click-to-close="!isProcessing" 
    :esc-to-close="!isProcessing"
    :id="'delete-confirm-dialog'"
    :z-index="10000"
    :requireConfirmation="requireConfirmation"
    :message="message"
    :title="title"
    dialogType="delete"
    :confirmButtonText="'Evet, Sil'"
    :cancelButtonText="'İptal'"
    confirmButtonColor="danger"
    cancelButtonColor="neutral"
    buttonSize="md"
    :showCancelButton="true"
    :showConfirmButtonIcon="true"
    confirmButtonIcon="delete"
    :auto-close="false"
    @confirm="confirm"
    @decline="$emit('update:show', false)"
  >
    <!-- Belge listesi -->
    <div v-if="showDetails && ids.length > 0" class="mt-4">
      <div class="border rounded p-3 bg-gray-50 max-h-40 overflow-y-auto">
        <div v-for="(id, index) in ids" :key="index" class="py-1 border-b last:border-0 text-gray-700">
          {{ getItemName(id) }}
        </div>
      </div>
    </div>

    <!-- Hata mesajı -->
    <div v-if="errorMessage" class="mt-4 text-sm text-red-600 bg-red-50 p-3 rounded border border-red-200">
      {{ errorMessage }}
    </div>
  </VDialog>
</template>

<script setup>
import { computed } from 'vue'
import VDialog from '@/components/feedback/VDialog/VDialog.vue'

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  ids: {
    type: Array,
    default: () => [],
  },
  isProcessing: {
    type: Boolean,
    default: false,
  },
  singleItemName: {
    type: String,
    default: 'belge',
  },
  multipleItemsName: {
    type: String,
    default: 'belge',
  },
  requireConfirmation: {
    type: Boolean,
    default: false,
  },
  showDetails: {
    type: Boolean,
    default: false,
  },
  itemNames: {
    type: Object,
    default: () => ({}),
  },
  errorMessage: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['update:show', 'confirm'])

// Dinamik başlık ve mesaj
const title = computed(() => {
  if (props.ids.length === 1) {
    return 'Belgeyi silmek istediğinizden emin misiniz?'
  }
  return `${props.ids.length} ${props.multipleItemsName} silmek istediğinizden emin misiniz?`
})

const message = computed(() => {
  if (props.ids.length === 1) {
    return `Bu işlem geri alınamaz ve ${props.singleItemName} kalıcı olarak silinecektir.`
  }
  return `Bu işlem geri alınamaz ve seçili ${props.multipleItemsName}ler kalıcı olarak silinecektir.`
})

// Helper function to get item names if provided
const getItemName = (id) => {
  return props.itemNames[id] || `${props.singleItemName} #${id}`
}

// Silme işlemini onayla
const confirm = () => {
  emit('confirm', props.ids)
}
</script>
